import React, { useEffect, useState } from 'react';

import { InfoPagesLayout } from 'Components/InfoPagesLayout/InfoPagesLayout';
import { makeRegServiceErrorMsg } from 'common/utils/common.utils';
import routes from 'common/constants/routing.constants';

export const VerifyEmailSentPage = () => {
  const [error, setError] = useState('');
  useEffect(() => {
    const query = new URLSearchParams(window?.location.search);
    const err = query.get('err');
    if (err !== 'null') setError(makeRegServiceErrorMsg(err));
  }, []);
  return (
    <InfoPagesLayout error={error.length > 0} to={routes.profile.path}>
      {error || "We've sent you a confirmation email."}
    </InfoPagesLayout>
  );
};
